import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { PageNumbers } from '@catalog/const';
import { I18nModule, PaginationModel } from '@spartacus/core';
import { InViewportDirective } from '../../../directives';

@Component({
  selector: 'sd-show-more',
  templateUrl: './show-more.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [I18nModule, InViewportDirective],
})
export class SdShowMoreComponent {
  @Input() pagination: PaginationModel;
  @Input() pageNumbers: PageNumbers;

  @Output() loadMore = new EventEmitter<number>();

  loadNext(): void {
    if (this.pageNumbers.next + 1 < (this.pagination.totalPages || 0)) {
      this.loadNextPage(this.pageNumbers.next + 1);
    }
  }

  loadNextPage(page: number): void {
    this.loadMore.emit(page);
  }

  onIntersected(inViewport: boolean): void {
    if (inViewport) {
      this.loadNext();
    }
  }
}
